module.exports = __webpack_public_path__ + "images/bubble-chart-icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bubble-chart-icon.png
// module id = 205
// module chunks = 0